// قائمة ولايات الجزائر الكاملة
export const algerianStates = [
  "أدرار", "الشلف", "الأغواط", "أم البواقي", "باتنة", "بجاية", "بسكرة", "بشار",
  "البليدة", "البويرة", "تمنراست", "تبسة", "تلمسان", "تيارت", "تيزي وزو", "الجزائر",
  "الجلفة", "جيجل", "سطيف", "سعيدة", "سكيكدة", "سيدي بلعباس", "عنابة", "قالمة",
  "قسنطينة", "المدية", "مستغانم", "المسيلة", "معسكر", "ورقلة", "وهران", "البيض",
  "إليزي", "برج بوعريريج", "بومرداس", "الطارف", "تندوف", "تيسمسيلت", "الوادي",
  "خنشلة", "سوق أهراس", "تيبازة", "ميلة", "عين الدفلى", "النعامة", "عين تيموشنت",
  "غرداية", "غليزان", "تيميمون", "برج باجي مختار", "أولاد جلال", "بني عباس",
  "عين صالح", "عين قزام", "تقرت", "جانت", "المغير", "المنيعة"
];

// خيارات المقاسات
export const sizeOptions = [
  { value: "S", label: "S" },
  { value: "M", label: "M" },
  { value: "L", label: "L" },
  { value: "XL", label: "XL" },
  { value: "XXL", label: "XXL" }
];

// خيارات الألوان
export const colorOptions = [
  { value: "أسود", label: "أسود" },
  { value: "أبيض", label: "أبيض" },
  { value: "أحمر", label: "أحمر" },
  { value: "أزرق", label: "أزرق" },
  { value: "أخضر", label: "أخضر" },
  { value: "وردي", label: "وردي" },
  { value: "رمادي", label: "رمادي" },
  { value: "بني", label: "بني" },
  { value: "بيج", label: "بيج" },
  { value: "بنفسجي", label: "بنفسجي" }
];

// دالة للتحقق من صحة رقم الهاتف الجزائري
export const validateAlgerianPhone = (phone) => {
  // إزالة المسافات والرموز الخاصة
  const cleanPhone = phone.replace(/[\s\-\(\)]/g, '');

  // التحقق من الأرقام الجزائرية
  const patterns = [
    /^0[5-7][0-9]{8}$/, // رقم محلي يبدأ بـ 05, 06, 07
    /^\+213[5-7][0-9]{8}$/, // رقم دولي +213
    /^213[5-7][0-9]{8}$/ // رقم دولي بدون +
  ];

  return patterns.some(pattern => pattern.test(cleanPhone));
};

// دالة لإنشاء رسالة واتساب
export const createOrderWhatsappMessage = (formData) => {
  const message = `طلب جديد من موقع سفيان للأفرشة.
الاسم: ${formData.fullName}
الهاتف: ${formData.phone}
الولاية: ${formData.state}
البلدية: ${formData.municipality}
المقاس: ${formData.size}
اللون: ${formData.color}
ملاحظات: ${formData.notes || 'لا توجد ملاحظات'}`;

  return encodeURIComponent(message);
};

// دالة لإنشاء رابط واتساب
export const createOrderWhatsappUrl = (formData, whatsappNumber = "2130657362317") => {
  const message = createOrderWhatsappMessage(formData);
  return `https://wa.me/${whatsappNumber}?text=${message}`;
};

// دالة لإنشاء رابط ماسنجر لطلب كامل
export const createOrderMessengerUrl = (formData, pageId = "moda.lady.shop") => {
  const message = `🛍️ طلب جديد من الموقع:\n\nالاسم: ${formData.fullName}\nرقم الهاتف: ${formData.phone}\nالولاية: ${formData.state}\nالبلدية: ${formData.municipality}\nالمنتج: ${formData.product || "لم يتم التحديد"}\nالمقاس: ${formData.size}\nاللون: ${formData.color}\nملاحظات: ${formData.notes || "لا توجد ملاحظات"}\n\nشكراً لتسوقك معنا ❤️`;
  return `https://m.me/${pageId}?text=${encodeURIComponent(message)}`;
};

// دالة لإنشاء رابط ماسنجر من بيانات منتج فقط
export const createProductMessengerUrl = (product, selectedColor, pageId = "moda.lady.shop") => {
  const message = `🛍️ طلب جديد من الموقع:\n\nالمنتج: ${product.title}\nالمقاس: ${product.size || ''}\nاللون: ${selectedColor}\n\nشكراً لتسوقك معنا ❤️`;
  return `https://m.me/${pageId}?text=${encodeURIComponent(message)}`;
};